import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormLayoutComponent } from '../form-layout/form-layout.component';

/**
 * Canonical shell for public and in-app forms that match the Contact page pattern:
 * {@link FormLayoutComponent} plus consistent trailing space before the next page section.
 */
@Component({
  selector: 'crowdctrl-standard-form',
  standalone: true,
  imports: [FormLayoutComponent],
  templateUrl: './standard-form.component.html',
  styleUrl: './standard-form.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class StandardFormComponent {
  @Input() heading = '';
  @Input() description = '';
  @Input() errorMessage = '';
  @Input() headingId: string | null = null;
  @Input() standalone = false;

  /** Forwarded to {@link FormLayoutComponent#padHorizontal}. */
  @Input() padHorizontal = false;

  /** Forwarded to {@link FormLayoutComponent#padVertical}. */
  @Input() padVertical = false;
}
